function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import JsonViewer from 'vue-json-viewer';
import { dataEventActionApi, dataEventInfoApi, dataEventCrudApi, databaseListApi, dataEventTypeApi, dataEventUpdateApi, crudGetCurlListApi, crudSendApi } from '@/api/develop';
import debounce from '@form-create/utils/lib/debounce';
export default {
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    conditionDialog: function conditionDialog() {
      return import('@/components/develop/conditionDialog');
    },
    updateContent: function updateContent() {
      return import('@/components/develop/updateContent');
    },
    toDoSchedule: function toDoSchedule() {
      return import('@/components/develop/toDoSchedule');
    },
    JsonViewer: JsonViewer
  },
  data: function data() {
    return {
      id: 0,
      // 触发器id
      crud_id: 0,
      // 实体id
      crud_name: '--',
      // 实体名称
      event_name: '--',
      // 触发动作名称
      info: {},
      // 触发器详情
      isRequest: false,
      jsonData: {},
      form: {
        name: '',
        title: '',
        action: [],
        timer: '',
        additional_search: [],
        field_options: [],
        template: '',
        timer_type: '',
        timer_options: {},
        options: {}
      },
      relatedData: {},
      groupList: [{
        form_field_uniqid: '',
        to_form_field_uniqid: ''
      }],
      // 分组字段
      action: [],
      // 选中的触发动作
      notify_type: [],
      // 选择通知类型
      actionList: [],
      // 获取执行动作类型
      targetEntity: [],
      // 目标实体
      approval: [],
      // 审批流程数据
      options: [],
      // 条件
      uniqidOptions: [],
      field: [],
      // 源字段
      dataList: [],
      // 接口列表
      curlLoading: false,
      value: '',
      additional_boolean: '0',
      userList: [],
      weekOptions: [{
        value: '1',
        label: '周一'
      }, {
        value: '2',
        label: '周二'
      }, {
        value: '3',
        label: '周三'
      }, {
        value: '4',
        label: '周四'
      }, {
        value: '5',
        label: '周五'
      }, {
        value: '6',
        label: '周六'
      }, {
        value: '7',
        label: '周日'
      }],
      timeOptions: [{
        value: '0',
        label: '每隔N秒'
      }, {
        value: '1',
        label: '每隔N分钟'
      }, {
        value: '2',
        label: '每隔N小时'
      }, {
        value: '3',
        label: '每隔N天'
      }, {
        value: '4',
        label: '每天'
      }, {
        value: '5',
        label: '每星期'
      }, {
        value: '6',
        label: '每月'
      }, {
        value: '7',
        label: '每年'
      }],
      activities: [{
        title: '当发生动作时',
        icon: 'iconfont icondangqian',
        color: '#1C9399',
        id: 1
      }, {
        title: '就执行操作',
        icon: 'iconfont icondangqian',
        color: '#eebe77',
        id: 2
      }, {
        title: '',
        icon: '',
        color: ''
      }]
    };
  },
  created: function created() {
    this.crud_id = Number(this.$route.query.crud_id);
    this.getAction();
    if (this.$route.query.id) {
      this.type = 'edit';
      this.id = this.$route.query.id;
      this.getAssociation();
    }
  },
  computed: {
    // 目标字段
    targetField: function targetField() {
      var _this = this;
      if (this.form.target_crud_id && this.targetEntity.length > 0) {
        var index = this.targetEntity.findIndex(function (item) {
          return item.id === _this.form.target_crud_id;
        });
        if (this.info.event === 'group_aggregate') {
          var formData = this.targetEntity[index].rule_field.filter(function (item) {
            return !['file', 'image'].includes(item.form_value);
          });
          return formData;
        } else {
          var _formData = [];
          if (this.targetEntity[index] && this.targetEntity[index].field.length > 0) {
            _formData = this.targetEntity[index].field.filter(function (item) {
              return !['file', 'image'].includes(item.form_value);
            });
          } else {
            _formData = [];
          }
          return _formData;
        }
      }
    },
    // 分组聚合字段
    groupField: function groupField() {
      var _this2 = this;
      if (this.form.target_crud_id && this.targetEntity.length > 0) {
        var index = this.targetEntity.findIndex(function (item) {
          return item.id === _this2.form.target_crud_id;
        });
        if (this.info.event === 'group_aggregate') {
          return this.targetEntity[index].field;
        } else {
          return [];
        }
      }
    },
    actionChange: function actionChange() {
      if (!this.action.includes('timer')) {
        this.form.timer = '';
      }
    },
    // 设置条件内容
    additional_search: {
      get: function get() {
        return this.$store.state.business.fieldOptions.list;
      },
      set: function set(val) {}
    },
    // 设置条件内容
    additional_Type: {
      get: function get() {
        return this.$store.state.business.fieldOptions.type;
      },
      set: function set(val) {}
    },
    additional_search_boolean: {
      get: function get() {
        return this.$store.state.business.fieldOptions.additional_search_boolean;
      },
      set: function set(val) {}
    }
  },
  watch: {
    // 给条件设置组装数据
    additional_search: function additional_search(val) {
      var _this3 = this;
      this.form[this.additional_Type] = [];
      val.map(function (item) {
        var obj = {
          operator: item.value,
          form_field_uniqid: item.field,
          value: item.option,
          obj: item
        };
        if (!item.option && item.category === 2) {
          obj.value = [];
          item.options.userList.map(function (i) {
            obj.value.push(i.value);
          });
        } else if (!item.option && item.category === 1) {
          obj.value = [];
          item.options.depList.map(function (i) {
            obj.value.push(i.id);
          });
        }
        if (obj.operator === 'between') {
          var data = {
            min: item.min,
            max: item.max
          };
          obj.value = data;
        }
        _this3.$nextTick(function () {
          _this3.form[_this3.additional_Type].push(obj);
        });
      });
    },
    additional_search_boolean: function additional_search_boolean(val) {
      // 条件设置-条件规则
      if (this.additional_Type === 'additional_search') {
        this.form.additional_search_boolean = this.additional_search_boolean;
      } else if (this.additional_Type === 'aggregate_data_search') {
        this.form.aggregate_data_search_boolean = this.additional_search_boolean;
      } else if (this.additional_Type === 'aggregate_target_search') {
        this.form.aggregate_target_search_boolean = this.additional_search_boolean;
      } else if (this.additional_Type === 'testOptions') {
        this.form.options = {
          search: this.form.testOptions,
          search_boolean: this.additional_search_boolean
        };
      }
    }
  },
  methods: {
    // 数据提交
    save: debounce(function (val) {
      var _this4 = this;
      if (['field_aggregate', 'group_aggregate'].includes(this.info.event)) {
        this.form.aggregate_field_rule = this.$refs.updateContent[0].updateList;
      } else if (['field_update', 'auto_create', 'get_data', 'push_data'].includes(this.info.event)) {
        this.form.field_options = this.$refs.updateContent[0].updateList;
      }
      // 分组聚合的数据
      if (this.info.event === 'group_aggregate') {
        this.form.aggregate_data_field = this.$refs.updateContent[0].groupList;
      }
      if (this.info.event === 'send_notice') {
        this.form.send_user = [];
        if (this.userList.length == 0) {
          return this.$message.error('请先添加成员');
        }
        this.userList.map(function (item) {
          _this4.form.send_user.push(item.id);
        });
        this.form.options = {
          title: this.form.title
        };
        this.form.notify_type = this.notify_type;
      }
      if (this.info.event === 'to_do_schedule') {
        var formObj = this.$refs.toDoSchedule[0].form;
        for (var key in formObj) {
          this.form.options[key] = formObj[key];
        }
      }
      this.form.action = this.action;
      if (!this.form.name) {
        return this.$message.error('触发器名称不能为空');
      }
      if (!this.form.action) {
        return this.$message.error('触发动作不能为空');
      }
      if (this.additional_Type === 'testOptions') {
        this.form.options = {
          search: this.form.testOptions,
          search_boolean: this.additional_search_boolean
        };
      }
      dataEventUpdateApi(this.id, this.form).then(function (res) {
        if (val == 1 && res.status == 200) {
          _this4.handleClose();
        }
      });
    }, 1000),
    // 打开条件设置弹窗
    OpenSettings: function OpenSettings(type) {
      var list = [];
      if (this.form[type] && this.form[type].length > 0) {
        this.form[type].map(function (item) {
          list.push(item.obj);
        });
      } else {
        list = [];
      }
      var boolean = '0';
      if (type === 'additional_search') {
        boolean = this.form.additional_search_boolean + '' || '0';
      } else if (type === 'aggregate_data_search') {
        boolean = this.form.aggregate_data_search_boolean + '' || '0';
      } else if (type === 'aggregate_target_search') {
        boolean = this.form.aggregate_target_search_boolean + '' || '0';
      } else if (type === 'testOptions') {
        boolean = this.form.options ? this.form.options.search_boolean + '' : '0';
      }
      this.additional_boolean = boolean;
      var data = {
        list: list,
        type: type,
        additional_search_boolean: boolean
      };
      this.$store.commit('uadatefieldOptions', data);
      this.$store.commit('updateConditionDialog', true);
    },
    changeTargetCrudId: function changeTargetCrudId() {
      this.$refs.updateContent[0].updateList = [];
    },
    // 获取数据-接口列表
    getDataList: function getDataList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var objData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              objData = {
                page: 1,
                limit: 0
              };
              if (_this5.info.event == 'push_data') {
                objData['method'] = 'post';
              }
              _context.next = 4;
              return crudGetCurlListApi(objData);
            case 4:
              data = _context.sent;
              _this5.dataList = data.data.list;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 发送请求
    crudSendFn: function crudSendFn(val) {
      var _this6 = this;
      this.field = [];
      if (!this.form.curl_id) return this.$message.error('链接地址不能为空');
      this.curlLoading = true;
      crudSendApi(this.form.curl_id).then(function (res) {
        if (res.status == 200) {
          _this6.jsonData = res.data;
          if (val) {
            _this6.isRequest = true;
          }
          var key = res.data.key;
          key.map(function (item) {
            var obj = {
              label: item,
              value: item
            };
            _this6.field.push(obj);
          });
        }
        _this6.curlLoading = false;
      });
    },
    handleClick: function handleClick(val, type) {
      if (type === 1) {
        this.$set(this.form, 'title', this.form.title + '{' + val.value + '}');
        this.onInput();
      } else {
        this.form.template = this.form.template + '{' + val.value + '}';
      }
    },
    getStr: function getStr(type) {
      switch (type) {
        case '0':
          return "\u6BCF\u9694".concat(this.form.timer_options.second || 'N', "\u79D2\u6267\u884C\u4E00\u6B21");
        case '1':
          return "\u6BCF\u9694".concat(this.form.timer_options.minute || 'N', "\u5206\u949F\u6267\u884C\u4E00\u6B21");
        case '2':
          return "\u6BCF\u9694".concat(this.form.timer_options.hour || 'N', "\u5C0F\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206\u949F\u6267\u884C\u4E00\u6B21");
        case '3':
          return "\u6BCF\u9694".concat(this.form.timer_options.day || 'N', "\u5929").concat(this.form.timer_options.hour || 'N', "\u5C0F\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206\u949F\u6267\u884C\u4E00\u6B21");
        case '4':
          return "\u6BCF\u5929".concat(this.form.timer_options.hour || 'N', "\u5C0F\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206\u949F").concat(this.form.timer_options.second || 'N', "\u79D2\u6267\u884C\u4E00\u6B21");
        case '5':
          return "\u6BCF\u4E2A\u661F\u671F".concat(this.form.timer_options.weekday || 'N', "\u7684").concat(this.form.timer_options.hour || 'N', "\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206").concat(this.form.timer_options.second || 'N', "\u79D2\u6267\u884C\u4E00\u6B21");
        case '6':
          return "\u6BCF\u6708".concat(this.form.timer_options.day || 'N', "\u65E5").concat(this.form.timer_options.hour || 'N', "\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206").concat(this.form.timer_options.second || 'N', "\u79D2\u6267\u884C\u4E00\u6B21");
        case '7':
          return "\u6BCF\u5E74".concat(this.form.timer_options.month || 'N', "\u6708").concat(this.form.timer_options.day || 'N', "\u65E5\u7684").concat(this.form.timer_options.hour || 'N', "\u65F6").concat(this.form.timer_options.minute || 'N', "\u5206").concat(this.form.timer_options.second || 'N', "\u79D2\u6267\u884C\u4E00\u6B21");
      }
    },
    numberChange: function numberChange(val, maxNum) {
      var _this7 = this;
      //重新渲染
      this.$nextTick(function () {
        //比较输入的值和最大值，返回小的
        var num = Math.min(Number(_this7.form.timer_options[val]), maxNum);
        //输入负值的情况下， = 0（可根据实际需求更该）
        if (num < 0) {
          _this7.form.timer_options[val] = 0;
        } else {
          //反之
          _this7.form.timer_options[val] = num;
        }
      });
    },
    onInput: function onInput() {
      this.$forceUpdate();
    },
    // 动态获取子组件数据来源
    getOptions: function getOptions(event) {
      var eventList = [];
      if (['get_data', 'push_data', 'field_update', 'auto_create'].includes(event)) {
        eventList = this.form.field_options;
      } else if (event === 'field_aggregate') {
        eventList = this.form.aggregate_field_rule;
      } else if (event === 'group_aggregate') {
        eventList = this.form.aggregate_field_rule;
      }
      if ((!eventList || eventList.length == 0) && event !== '') {
        eventList = [{
          form_field_uniqid: '',
          operator: this.options[0].value,
          to_form_field_uniqid: ''
        }];
      }
      return eventList;
    },
    // 获取触发器关联数据
    getAssociation: function getAssociation() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              dataEventCrudApi(_this8.crud_id, _this8.id).then(function (res) {
                _this8.relatedData = res.data;
                _this8.targetEntity = res.data.list;
                _this8.options = res.data.update_type;
                _this8.uniqidOptions = [{
                  label: '字段值',
                  value: 'field_value'
                }];
                _this8.field = res.data.field;
                _this8.approval = res.data.approve;
                _this8.getInfo();
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取实体数据-渲染实体名称
    getEntity: function getEntity(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var where, data, list, index;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              where = {
                cate_id: ''
              };
              _context3.next = 3;
              return databaseListApi(where);
            case 3:
              data = _context3.sent;
              list = data.data.list;
              index = list.findIndex(function (item) {
                return item.id === id;
              });
              _this9.crud_name = list[index].table_name;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 获取触发动作
    getEvent: function getEvent(event) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dataEventTypeApi(_this10.crud_id);
            case 2:
              data = _context4.sent;
              index = data.data.findIndex(function (item) {
                return item.value === event;
              });
              _this10.event_name = data.data[index].label;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 获取执行动作类型
    getAction: function getAction() {
      var _this11 = this;
      dataEventActionApi().then(function (res) {
        _this11.actionList = res.data;
      });
    },
    // 获取触发器详情
    getInfo: function getInfo() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              dataEventInfoApi(_this12.id).then(function (res) {
                _this12.info = res.data;
                _this12.form = res.data;
                _this12.form.timer_type = _this12.form.timer_type + '';
                if (_this12.info.event == 'auto_approve') {
                  _this12.actionList = _this12.actionList.filter(function (item) {
                    return !['approve_success', 'approve_create', 'timer'].includes(item.value);
                  });
                } else if (['push_data', 'to_do_schedule'].includes(_this12.info.event)) {
                  if (_this12.info.event === 'push_data') {
                    _this12.form.curl_id = _this12.form.curl_id == 0 ? '' : _this12.form.curl_id;
                    _this12.getDataList();
                  }
                  _this12.actionList = _this12.actionList.filter(function (item) {
                    return !['timer'].includes(item.value);
                  });
                } else if (_this12.info.event == 'auto_revoke_approve') {
                  _this12.actionList = _this12.actionList.filter(function (item) {
                    return !['approve_create', 'timer'].includes(item.value);
                  });
                } else if (_this12.info.event == 'get_data') {
                  _this12.actionList = [{
                    label: '定期执行',
                    value: 'timer'
                  }];
                  _this12.form.curl_id = _this12.form.curl_id == 0 ? '' : _this12.form.curl_id;
                  _this12.getDataList();
                  _this12.field = [];
                  if (_this12.form.curl_id) {
                    _this12.crudSendFn();
                  }
                }
                if (_this12.form.timer == 0) {
                  _this12.form.timer = '';
                }
                _this12.value = _this12.form.name;
                _this12.action = _this12.info.action || [];
                if (_this12.id > 0 && _this12.info.event === 'group_aggregate') {} else {
                  _this12.form.target_crud_id = _this12.info.target_crud_id;
                }
                _this12.form.field_options = _this12.info.field_options;
                var list = [];
                if (_this12.info.event === 'group_aggregate') {
                  _this12.groupList = _this12.form.aggregate_data_field || [];
                }
                if (_this12.info.event === 'data_check') {
                  if (_this12.form.options && _this12.form.options.search && _this12.form.options.search.length > 0) {
                    _this12.$set(_this12.form, 'testOptions', _this12.form.options.search);
                  } else {
                    _this12.$set(_this12.form, 'testOptions', []);
                  }
                }
                _this12.getOptions(_this12.info.event);
                if (_this12.info.additional_search && _this12.info.additional_search.length > 0) {
                  _this12.info.additional_search.map(function (item) {
                    list.push(item.obj);
                  });
                  _this12.additional_search = list;
                }
                if (_this12.form.target_crud_id !== 0) {
                  // this.disabled = true
                } else if (_this12.form.target_crud_id == 0 && ['auto_create', 'field_aggregate'].includes(_this12.info.event)) {
                  _this12.form.target_crud_id = _this12.targetEntity[0] ? _this12.targetEntity[0].id : '';
                  // this.disabled = false
                } else {
                  _this12.form.target_crud_id = _this12.info.crud_id;
                  // this.disabled = false
                }
                if (_this12.info.event === 'send_notice') {
                  _this12.form.title = _this12.form.options.title;
                  _this12.notify_type = _this12.form.notify_type.map(Number) || [];
                }
                if (res.data.send_user && res.data.send_user.length > 0) {
                  _this12.userList = res.data.send_user;
                  _this12.userList.forEach(function (item) {
                    item.value = item.id;
                  });
                }
                _this12.list = _this12.getEntity(_this12.info.crud_id);
                _this12.getEvent(_this12.info.event);
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 选择成员回调
    getSelectList: function getSelectList(data) {
      if (data.length > 0) {
        data.forEach(function (item) {
          item.id = item.value;
        });
      }
      this.userList = data;
    },
    cardTag: function cardTag(index) {
      this.userList.splice(index, 1);
    },
    handleClose: function handleClose() {
      window.opener = null;
      window.open('about:blank', '_top').close();
    },
    nameSubmit: function nameSubmit() {
      this.form.name = this.value;
      this.close();
    },
    close: function close() {
      this.$refs.popoverRef.doClose();
    },
    getLabel: function getLabel(val) {
      var obj = {
        field_update: '更新规则',
        field_aggregate: '聚合规则',
        group_aggregate: '聚合规则',
        auto_create: '创建规则'
      };
      return obj[val];
    }
  }
};